import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TabCategory } from '../../../documents/models/tab-category';
import { UrlBuilder } from '../../../core/url-builder/url-builder';
import { UserPermissionsStorage } from '../../../user-permissions/user-permissions-storage';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';

@Component({
    selector: 'coordinator-e-query-tabs',
    template: require('./coordinator-e-query-tabs.component.html'),
    styles: [require('./coordinator-e-query-tabs.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoordinatorEQueryTabsComponent {

    public tabs$: Observable<TabCategory[]>;

    constructor(
        private urlBuilder: UrlBuilder,
        userPermissionsStorage: UserPermissionsStorage
    ) {
        this.tabs$ = combineLatest([
            userPermissionsStorage.userPermissions
        ]).pipe(
            map(([permissions]) => {
                const tabs: TabCategory[] = [];

                const eQuerySummaryUrl = this.urlBuilder
                    .esa()
                    .admin()
                    .coordinatorEQuery()
                    .eQuerySummary()
                    .url();

                tabs.push({ name: 'eQuery Summary', url: eQuerySummaryUrl });

                if (permissions.has('EQueryAdministration')) {
                    const hideUnHideUrl = this.urlBuilder
                        .esa()
                        .admin()
                        .coordinatorEQuery()
                        .hideEQueries()
                        .url();
                    const escalationEmailsUrl = this.urlBuilder
                        .esa()
                        .admin()
                        .coordinatorEQuery()
                        .escalationEmails()
                        .url();
                    const usageReportUrl = this.urlBuilder
                        .esa()
                        .admin()
                        .coordinatorEQuery()
                        .usageReport()
                        .url();

                    tabs.push({ name: 'Hide eQuery', url: hideUnHideUrl });
                    tabs.push({ name: 'Escalation Emails', url: escalationEmailsUrl });
                    tabs.push({ name: 'Usage Reports', url: usageReportUrl });
                }

                return tabs;
            }),
            publishReplay(1),
            refCount(),
        );
    }
}